var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 14.668H17.3334C15.8607 14.668 14.6667 15.8619 14.6667 17.3346V22.668C14.6667 24.1407 15.8607 25.3346 17.3334 25.3346H38.6667C40.1395 25.3346 41.3334 24.1407 41.3334 22.668V17.3346C41.3334 15.8619 40.1395 14.668 38.6667 14.668Z",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 30.668H17.3334C15.8607 30.668 14.6667 31.8619 14.6667 33.3346V38.668C14.6667 40.1407 15.8607 41.3346 17.3334 41.3346H38.6667C40.1395 41.3346 41.3334 40.1407 41.3334 38.668V33.3346C41.3334 31.8619 40.1395 30.668 38.6667 30.668Z",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H20.0133",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36H20.0133",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/user_setting.813348781e383ec1eaffc92e0e006bba.svg";
export { ForwardRef as ReactComponent };